import {
  getUser,
  getUserEnt,
  queryGuideShow,
  queryGuiderecord,
  getAreas,
  selMemberVip
} from "@/api/app";

export default {
  namespaced: true,
  state: {
    opened: true,
    userInfo: {},
    userIdentity: {}
  },
  mutations: {
    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo || {};
    },
    setUserIdentity: (state, userIdentity) => {
      state.userIdentity = userIdentity || {};
    },
    setOpened: (state) => {
      state.opened = !state.opened;
    }
  },
  actions: {
    // 用户信息
    async getUserInfo({ commit }) {
      const { data } = await getUser();
      if (data && data.image) {
        data.image = `${process.env.VUE_APP_FILES}${data.image}`;
      }
      commit("setUserInfo", data);
    },
    // 用户当前身份（个人/企业）
    async getUserIdentity({ commit }) {
      const { data } = await getUserEnt();
      commit("setUserIdentity", data);
    },
    async queryGuideShow(context, params) {
      const data = await queryGuideShow(params);
      return data;
    },
    async queryGuiderecord(context, params) {
      const data = await queryGuiderecord(params);
      return data;
    },
    async getAreas(context, params) {
      const { data } = await getAreas(params);
      return data;
    },
    async selMemberVip(context, params) {
      const { data } = await selMemberVip(params);
      return data;
    }
  }
};
